// extracted by mini-css-extract-plugin
export default {"userCol":"agentHistory_userCol__5eiol","dateCol":"agentHistory_dateCol__kZ6ED","renderStyles":"agentHistory_renderStyles__Cn1kG"};